import React from 'react';

import { resultSubtitle } from 'src/components/molecules/AddressSearch/styles/styles';

export type ResultSubtitleProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLParagraphElement>,
  HTMLParagraphElement
>;

export const ResultSubtitle = (props: ResultSubtitleProps) => (
  <p css={resultSubtitle} {...props}>
    {props.children}
  </p>
);
